import { hslaConverter, palette, color } from '@conserveit/blocks'

const ink = hslaConverter(color.theme.typography.ink, 'hex')
const scrollColor = hslaConverter(color.theme.typography.subdued, 'hex')

export const scrollBar2DChartBaseConfig = {
  divLineAlpha: 0,
  maxBarHeight: 32,
  numvisibleplot: 8,
  showPlotBorder: true,
  plotBorderThickness: 1,
  plotBorderColor: hslaConverter(palette.pureWhite, 'hex'),
  placeValuesInside: false,
  valuePadding: 4,
  valueFontSize: 14,
  valueFontBold: true,
  showYAxisValues: true,
  yAxisValueAlpha: 0,
  yAxisValueFontSize: 0,
  yAxisNamePadding: 0,
  valueFontColor: ink,
  legendItemFontColor: ink,
  labelFontColor: ink,
  xAxisNameFontColor: ink,
  yAxisValueFontColor: ink,
  yAxisNameFontColor: ink,
  flatScrollbars: true,
  scrollColor,
  scrollWidth: 12
}

export const msColumn2dBaseConfig = {
  divLineAlpha: 0,
  maxBarHeight: 32,
  canvasBgAlpha: 100,
  plotHoverEffect: 0,
  showPlotBorder: true,
  plotBorderThickness: 1,
  plotBorderColor: hslaConverter(palette.pureWhite, 'hex'),
  yAxisNamePadding: 10,
  valueFontColor: ink,
  legendItemFontColor: ink,
  labelFontColor: ink,
  xAxisNameFontColor: ink,
  yAxisValueFontColor: ink,
  yAxisNameFontColor: ink,
  theme: 'fusion'
}
